import { Tracking } from '@gjensidige/core-analytics';

import { InsuranceHelper } from './utils/InsuranceHelper';

class Tracker {
  options = {
    application_module: 'offer',
    application_name: 'webshop',
    application_partner: Tracker.getApplicationPartner(),
    application_version: '2.0',
    business_area: 'insurance',
    customer_segment: 'private',
    page_pathname: 'offers',
    page_title: 'webshop-frontend-se',
    scenario_name: '',
    scenario_step: ''
  };

  constructor() {
    this.tracking = new Tracking(this.options);
  }

  static getApplicationPartner() {
    const channelFromURL = InsuranceHelper.getPolicyAndChannelFromUrl()?.channel;
    if (channelFromURL) {
      return Tracker.handleDifferentBrands(channelFromURL.toLowerCase());
    }
    return Tracker.handleDifferentBrands(Tracker.getChannelFromSession()?.toLowerCase());
  }

  static getChannelFromSession() {
      const urlParams = document.location.href.split('?')[1] || '';
      const searchParams = new URLSearchParams(urlParams);
      const sessionKey = searchParams.get('sessionKey') || '';
      if (sessionKey) {
        const dataFromSession = JSON.parse(
          sessionStorage.getItem(sessionKey) || '{}'
        );
        return dataFromSession.channel || 'gjensidige';
      }
      return 'gjensidige';
  }

  // This function is Mainly used to handle same brand name for different 
  // channels name, the reason is same brand has different agreements in F2100, ex: HGF 195 & 196
  static handleDifferentBrands(brand) {
    if (brand === 'hgfppi') {
      return 'hgf';
    }
    return brand;
  }

  getOptions() {
    if (this.tracking.options.application_name === 'NOT-SET') {
      this.tracking = new Tracking(this.options);
    }
    return this.tracking.options;
  }

  setOptions = (additionalOptions) => {
    const options = {
      ...this.tracking.options,
      ...additionalOptions
    };
    this.tracking.setOptions(options);
  };

  trackEvent = (options) => {
    this.tracking.trackEvent(options);
  };

  trackScenerioStep = (appModule, scenarioName, scenarioStep) => {
    const pathName = `/apps/${this.options.application_name}/${appModule}/${scenarioName}/${scenarioStep}`;
    const data = {
      ...this.tracking.options,
      application_module: appModule,
      scenario_name: scenarioName,
      scenario_step: scenarioStep,
      page_pathname: pathName
    }
    this.tracking.trackView(data);
  };

  trackView = (data) => {
    this.tracking.trackView(data);
  };

  trackEcommerceEvent = (eventConfig, options) => {
    this.tracking.trackEcommerceEvent(eventConfig, options);
  };

  trackEcommerceView = (options) => {
    this.tracking.trackEcommerceView(options);
  };
}

const tracker = new Tracker();

export default tracker;
